import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.dashboard');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-dashboard',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.dashboard/view.scss */
:host {
  display: block;
  min-height: 100%;
}

.dashboard-shell {
  --db-primary: #1168f3;
  --db-primary-strong: #1c4efc;
  --db-navy: #0a192f;
  --db-ink: #0b1019;
  --db-text: #4c5665;
  --db-muted: #98a0ad;
  --db-line: #e4e6eb;
  --db-surface: #ffffff;
  --db-canvas: #f7f9fc;
  --db-space-panel: 24px;
  --db-space-section: 32px;
  min-height: 100%;
  box-sizing: border-box;
  width: 100%;
  max-width: 1440px;
  margin: 0 auto;
  padding: 24px 24px 32px;
  background: var(--db-canvas);
  color: var(--db-ink);
  font-family: Inter, "Pretendard Variable", Pretendard, "Noto Sans KR", sans-serif;
}

button,
input {
  font: inherit;
}

button {
  cursor: pointer;
}

.dashboard-loading {
  display: flex;
  min-height: calc(100vh - 96px);
  align-items: center;
  justify-content: center;
  gap: 14px;
  color: var(--db-text);
}

.dashboard-loading strong,
.dashboard-loading p {
  display: block;
  margin: 0;
}

.dashboard-loading strong {
  color: var(--db-ink);
  font-size: 15px;
  font-weight: 700;
}

.dashboard-loading p {
  margin-top: 3px;
  font-size: 13px;
}

.dashboard-loading-spinner {
  width: 34px;
  height: 34px;
  border: 3px solid #dbe7ff;
  border-top-color: var(--db-primary);
  border-radius: 999px;
  animation: dashboard-spin 0.8s linear infinite;
}

@keyframes dashboard-spin {
  to {
    transform: rotate(360deg);
  }
}
.dashboard-notice {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr) auto;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
  border: 1px solid #d2dcfe;
  border-radius: 10px;
  background: #f4f7ff;
  padding: 11px 14px;
}

.dashboard-notice-icon {
  display: inline-flex;
  width: 32px;
  height: 32px;
  align-items: center;
  justify-content: center;
  border-radius: 9px;
  background: #e6edff;
  color: var(--db-primary-strong);
}

.dashboard-notice strong,
.dashboard-notice p {
  margin: 0;
}

.dashboard-notice strong {
  color: #17223a;
  font-size: 13px;
}

.dashboard-notice p {
  margin-top: 2px;
  color: #667085;
  font-size: 12px;
}

.dashboard-notice button {
  display: inline-flex;
  min-height: 34px;
  align-items: center;
  gap: 7px;
  border: 1px solid #c4d2f7;
  border-radius: 8px;
  background: #ffffff;
  padding: 0 12px;
  color: #2458c6;
  font-size: 12px;
  font-weight: 700;
}

.dashboard-kpi-grid {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 16px;
}

.dashboard-kpi {
  position: relative;
  min-width: 0;
  min-height: 141px;
  overflow: hidden;
  border: 1px solid #dfe3ea;
  border-radius: 10px;
  background: var(--db-surface);
  padding: 20px;
  transition: border-color 0.18s ease, box-shadow 0.18s ease, transform 0.18s ease;
}

.dashboard-kpi:hover {
  border-color: #c9d4e8;
  box-shadow: 0 12px 30px rgba(23, 42, 73, 0.07);
  transform: translateY(-2px);
}

.dashboard-kpi-heading,
.dashboard-kpi-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}

.dashboard-kpi-heading {
  color: #667085;
  font-size: 13px;
  font-weight: 700;
}

.dashboard-kpi-heading strong {
  color: #00b96b;
  font-size: 12px;
  font-weight: 700;
}

.dashboard-kpi-heading strong.is-down {
  color: #ff3158;
}

.dashboard-kpi-heading strong.is-neutral {
  color: #98a0ad;
}

.dashboard-kpi-value {
  display: flex;
  align-items: baseline;
  gap: 5px;
  margin: 5px 0 0;
  color: var(--db-ink);
}

.dashboard-kpi-value strong {
  overflow: hidden;
  font-size: clamp(21px, 1.5vw, 27px);
  font-weight: 800;
  letter-spacing: -0.045em;
  line-height: 1.35;
  text-overflow: ellipsis;
}

.dashboard-kpi-value small {
  color: #4c5665;
  font-size: 12px;
  font-weight: 600;
}

.dashboard-kpi-footer {
  position: absolute;
  right: 20px;
  bottom: 19px;
  left: 20px;
}

.dashboard-kpi-footer button {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  border: 0;
  background: transparent;
  padding: 0;
  color: #98a0ad;
  font-size: 12px;
}

.dashboard-kpi-footer button:hover {
  color: var(--db-primary);
}

.dashboard-kpi-icon {
  display: inline-flex;
  width: 40px;
  height: 40px;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  background: #eff5ff;
  color: #156df5;
  font-size: 17px;
}

.dashboard-kpi-cyan .dashboard-kpi-icon {
  background: #eefbfb;
  color: #00a9bd;
}

.dashboard-kpi-violet .dashboard-kpi-icon {
  background: #f2efff;
  color: #6554ef;
}

.dashboard-kpi-teal .dashboard-kpi-icon {
  background: #edf8f5;
  color: #149674;
}

.dashboard-kpi-amber .dashboard-kpi-icon {
  background: #fff8e9;
  color: #ff8a00;
}

.dashboard-section {
  min-width: 0;
  margin-top: var(--db-space-section);
}

.dashboard-section-heading {
  display: flex;
  min-height: 38px;
  align-items: flex-start;
  justify-content: space-between;
  gap: 14px;
  margin-bottom: 18px;
}

.dashboard-section-heading h2,
.dashboard-section-heading p {
  margin: 0;
}

.dashboard-section-heading h2 {
  color: var(--db-ink);
  font-size: 19px;
  font-weight: 800;
  letter-spacing: -0.025em;
  line-height: 1.35;
}

.dashboard-section-heading p {
  margin-top: 3px;
  color: #7b8494;
  font-size: 12px;
  line-height: 1.45;
}

.dashboard-section-link {
  display: inline-flex;
  min-height: 34px;
  flex: none;
  align-items: center;
  gap: 7px;
  border: 1px solid #dce2eb;
  border-radius: 8px;
  background: #ffffff;
  padding: 0 12px;
  color: #4c5665;
  font-size: 12px;
  font-weight: 700;
}

.dashboard-section-link:hover {
  border-color: #b7cdfd;
  color: var(--db-primary);
}

.dashboard-process-grid,
.dashboard-recent-grid {
  display: grid;
  grid-template-columns: repeat(7, minmax(0, 1fr));
  gap: 16px;
}

.dashboard-process-grid {
  margin-top: 2px;
}

.dashboard-process-card {
  display: flex;
  min-width: 0;
  min-height: 202px;
  flex-direction: column;
  align-items: stretch;
  border: 1px solid #dfe3ea;
  border-radius: 10px;
  background: #ffffff;
  padding: 20px;
  text-align: left;
  transition: border-color 0.18s ease, box-shadow 0.18s ease, transform 0.18s ease;
}

.dashboard-process-card:hover {
  border-color: #a9c2ff;
  box-shadow: 0 12px 28px rgba(28, 78, 252, 0.1);
  transform: translateY(-2px);
}

.dashboard-process-card.is-featured {
  border-color: #2759ff;
  background: linear-gradient(145deg, #2958ff 0%, #1d49ee 100%);
  color: #ffffff;
}

.dashboard-process-icon {
  display: inline-flex;
  width: 40px;
  height: 40px;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  background: #fff7ed;
  color: #ff8a00;
  font-size: 17px;
}

.dashboard-process-card:nth-child(2) .dashboard-process-icon {
  background: #f0f6ff;
  color: #196df2;
}

.dashboard-process-card:nth-child(3) .dashboard-process-icon {
  background: #effcfc;
  color: #00afc1;
}

.dashboard-process-card:nth-child(4) .dashboard-process-icon {
  background: #f2efff;
  color: #6956ef;
}

.dashboard-process-card:nth-child(5) .dashboard-process-icon {
  background: #faf0ff;
  color: #a83df1;
}

.dashboard-process-card:nth-child(6) .dashboard-process-icon {
  background: #fff6ed;
  color: #566171;
}

.dashboard-process-card:nth-child(7) .dashboard-process-icon {
  background: #eefaf5;
  color: #129875;
}

.dashboard-process-card.is-featured .dashboard-process-icon {
  background: rgba(255, 255, 255, 0.13);
  color: #ffffff;
}

.dashboard-process-copy {
  display: block;
  min-width: 0;
  margin-top: 20px;
}

.dashboard-process-copy strong,
.dashboard-process-copy small {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dashboard-process-copy strong {
  color: inherit;
  font-size: 16px;
  font-weight: 800;
}

.dashboard-process-copy small {
  margin-top: 7px;
  color: #6a7181;
  font-size: 12px;
}

.dashboard-process-card.is-featured .dashboard-process-copy small {
  color: rgba(255, 255, 255, 0.86);
}

.dashboard-process-count {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 8px;
  margin-top: auto;
  border-top: 1px solid #e8ebf0;
  padding-top: 16px;
}

.dashboard-process-count small {
  color: #6a7181;
  font-size: 12px;
}

.dashboard-process-count strong {
  color: inherit;
  font-size: 22px;
  font-weight: 800;
}

.dashboard-process-card.is-featured .dashboard-process-count {
  border-top-color: rgba(255, 255, 255, 0.17);
}

.dashboard-process-card.is-featured .dashboard-process-count small {
  color: rgba(255, 255, 255, 0.84);
}

.dashboard-recent-grid {
  margin-top: 16px;
}

.dashboard-data-card {
  min-width: 0;
  min-height: 151px;
  border: 1px solid #dfe3ea;
  border-radius: 10px;
  background: #ffffff;
  padding: 10px 14px;
}

.dashboard-data-card-top,
.dashboard-data-card-meta {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.dashboard-data-card-top > span:last-child {
  color: #98a0ad;
  font-size: 12px;
}

.dashboard-data-card h3,
.dashboard-data-card p {
  overflow: hidden;
  margin: 0;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dashboard-data-card h3 {
  margin-top: 12px;
  color: #242d3b;
  font-size: 13px;
  font-weight: 700;
}

.dashboard-data-card p {
  margin-top: 5px;
  color: #7b8494;
  font-size: 12px;
}

.dashboard-data-card-meta {
  margin-top: 14px;
  border-top: 1px solid #e9ecf1;
  padding-top: 11px;
  color: #98a0ad;
  font-size: 12px;
}

.dashboard-type {
  display: inline-flex;
  min-height: 22px;
  align-items: center;
  border: 1px solid #c6dbff;
  border-radius: 4px;
  background: #f1f6ff;
  padding: 1px 7px;
  color: #1168f3;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.3;
  white-space: nowrap;
}

.dashboard-type-cyan {
  border-color: #a7edf1;
  background: #edfcfd;
  color: #009aab;
}

.dashboard-type-slate {
  border-color: #cfdae6;
  background: #f3f7fa;
  color: #536274;
}

.dashboard-type-violet {
  border-color: #d5c9ff;
  background: #f6f2ff;
  color: #7447e8;
}

.dashboard-type-amber {
  border-color: #ffd5a8;
  background: #fff8ed;
  color: #e36f00;
}

.dashboard-service-grid {
  display: grid;
  grid-template-columns: minmax(0, 1.45fr) minmax(300px, 0.95fr) minmax(280px, 0.9fr);
  gap: 16px;
}

.dashboard-service-grid > .dashboard-section {
  min-width: 0;
}

.dashboard-analysis-content {
  display: grid;
  min-height: 317px;
  grid-template-columns: minmax(195px, 0.92fr) minmax(235px, 1.08fr);
  gap: 16px;
}

.dashboard-analysis-feature {
  position: relative;
  min-width: 0;
  overflow: hidden;
  border-radius: 10px;
  background: linear-gradient(145deg, #145cff 0%, #3726ae 100%);
  padding: 18px 16px;
  color: #ffffff;
}

.dashboard-ai-badge {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.17);
  padding: 4px 9px;
  color: #ffffff;
  font-size: 12px;
  font-weight: 700;
}

.dashboard-analysis-feature h3,
.dashboard-analysis-feature p {
  position: relative;
  z-index: 1;
  margin: 0;
}

.dashboard-analysis-feature h3 {
  margin-top: 17px;
  font-size: 17px;
  font-weight: 800;
}

.dashboard-analysis-feature p {
  margin-top: 10px;
  color: rgba(255, 255, 255, 0.86);
  font-size: 12px;
  line-height: 1.65;
}

.dashboard-analysis-feature button {
  position: absolute;
  bottom: 16px;
  left: 16px;
  z-index: 2;
  display: inline-flex;
  min-height: 44px;
  align-items: center;
  gap: 14px;
  border: 0;
  border-radius: 9px;
  background: #ffffff;
  padding: 0 16px;
  color: #1757ea;
  font-size: 12px;
  font-weight: 800;
}

.dashboard-analysis-watermark {
  position: absolute;
  right: -8px;
  bottom: -15px;
  color: rgba(255, 255, 255, 0.08);
  font-size: 106px;
}

.dashboard-service-tiles {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 16px;
}

.dashboard-service-tiles button {
  display: flex;
  min-width: 0;
  min-height: 150px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  border: 1px solid #dfe3ea;
  border-radius: 10px;
  background: #ffffff;
  color: var(--db-ink);
}

.dashboard-service-tiles button:hover {
  border-color: #a9c2ff;
  background: #fbfcff;
}

.dashboard-service-tiles button > span {
  display: inline-flex;
  width: 56px;
  height: 56px;
  align-items: center;
  justify-content: center;
  border-radius: 14px;
  background: #edf5ff;
  color: #1071f4;
  font-size: 19px;
}

.dashboard-service-tiles button > span.is-cyan {
  background: #e9fbfb;
  color: #00aabd;
}

.dashboard-service-tiles button > span.is-violet {
  background: #f0efff;
  color: #6754ee;
}

.dashboard-service-tiles button > span.is-purple {
  background: #faf0ff;
  color: #b03ef2;
}

.dashboard-service-tiles button > span.is-red {
  background: #fff0ef;
  color: #ff4c5a;
}

.dashboard-service-tiles button > span.is-slate {
  background: #eff4f8;
  color: #5b6979;
}

.dashboard-service-tiles strong {
  display: block;
  max-width: 100%;
  overflow: hidden;
  font-size: 12px;
  font-weight: 700;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dashboard-learning-list {
  display: grid;
  min-height: 317px;
  align-content: stretch;
  gap: 16px;
}

.dashboard-learning-list article {
  display: flex;
  min-width: 0;
  min-height: 95px;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  border: 1px solid #dfe3ea;
  border-radius: 10px;
  background: #ffffff;
  padding: 14px 16px;
}

.dashboard-learning-list article > div:first-child {
  min-width: 0;
}

.dashboard-learning-list strong,
.dashboard-learning-list p {
  display: block;
  overflow: hidden;
  margin: 0;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dashboard-learning-list strong {
  color: #0b1019;
  font-size: 14px;
  font-weight: 800;
}

.dashboard-learning-list p {
  margin-top: 5px;
  color: #7b8494;
  font-size: 12px;
}

.dashboard-course-action {
  display: flex;
  flex: none;
  flex-direction: column;
  align-items: flex-end;
  gap: 9px;
}

.dashboard-course-action span {
  border-radius: 5px;
  background: #f3f4f6;
  padding: 4px 8px;
  color: #6a7181;
  font-size: 12px;
}

.dashboard-course-action button {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  border: 0;
  background: transparent;
  padding: 0;
  color: var(--db-primary);
  font-size: 12px;
  font-weight: 700;
}

.dashboard-environment-list {
  display: grid;
  min-height: 317px;
  align-content: stretch;
  gap: 16px;
}

.dashboard-environment-list article {
  position: relative;
  display: flex;
  min-width: 0;
  min-height: 150px;
  flex-direction: column;
  overflow: hidden;
  border-radius: 10px;
  padding: 18px 20px 0;
  color: #ffffff;
}

.dashboard-environment-list article.is-primary {
  background: linear-gradient(125deg, #087fee 0%, #0799f5 100%);
}

.dashboard-environment-list article.is-secondary {
  background: linear-gradient(125deg, #0f67ba 0%, #0054a7 100%);
}

.dashboard-environment-list article > i {
  position: absolute;
  right: 18px;
  top: 20px;
  color: rgba(0, 55, 130, 0.14);
  font-size: 48px;
}

.dashboard-environment-list h3,
.dashboard-environment-list p {
  position: relative;
  z-index: 1;
  margin: 0;
}

.dashboard-environment-list h3 {
  font-size: 16px;
  font-weight: 800;
}

.dashboard-environment-list p {
  margin-top: 6px;
  color: rgba(255, 255, 255, 0.82);
  font-size: 12px;
  line-height: 1.55;
}

.dashboard-environment-list button {
  display: flex;
  min-height: 42px;
  align-items: center;
  justify-content: center;
  gap: 7px;
  margin: auto -20px 0;
  border: 0;
  background: #ffffff;
  color: #3c4656;
  font-size: 12px;
  font-weight: 700;
}

.dashboard-insight-grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  gap: 16px;
}

.dashboard-chart-card,
.dashboard-status-table-wrap {
  min-height: 316px;
  border: 1px solid #dfe3ea;
  border-radius: 10px;
  background: #ffffff;
}

.dashboard-chart-card {
  position: relative;
  display: grid;
  grid-template-columns: 42px minmax(0, 1fr);
  grid-template-rows: minmax(0, 1fr) auto;
  padding: 24px 24px 17px 18px;
}

.dashboard-chart-scale {
  display: flex;
  height: 220px;
  flex-direction: column;
  justify-content: space-between;
  padding-bottom: 22px;
  color: #98a0ad;
  font-size: 12px;
}

.dashboard-chart-plot {
  position: relative;
  display: grid;
  height: 220px;
  grid-template-columns: repeat(7, minmax(0, 1fr));
  gap: 12px;
  padding: 0 8px;
}

.dashboard-chart-lines {
  position: absolute;
  inset: 0 0 22px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.dashboard-chart-lines i {
  display: block;
  border-top: 1px dashed #e8ebf0;
}

.dashboard-chart-column {
  position: relative;
  z-index: 1;
  display: grid;
  min-width: 0;
  grid-template-rows: minmax(0, 1fr) 22px;
  gap: 0;
}

.dashboard-chart-bars {
  display: flex;
  align-items: flex-end;
  justify-content: center;
  gap: 3px;
  padding: 0 3px;
}

.dashboard-chart-bars span {
  display: block;
  width: min(16px, 42%);
  min-height: 8px;
  border-radius: 4px 4px 0 0;
}

.dashboard-chart-bars .is-record {
  background: #2f7df1;
}

.dashboard-chart-bars .is-connection {
  background: #27c4bb;
}

.dashboard-chart-column small {
  overflow: hidden;
  align-self: end;
  color: #7b8494;
  font-size: 12px;
  text-align: center;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dashboard-chart-legend {
  display: flex;
  grid-column: 2;
  align-items: center;
  justify-content: center;
  gap: 18px;
  padding-top: 10px;
  color: #6a7181;
  font-size: 12px;
}

.dashboard-chart-legend span {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.dashboard-chart-legend i {
  display: block;
  width: 10px;
  height: 10px;
  border-radius: 2px;
  background: #2f7df1;
}

.dashboard-chart-legend i.is-connection {
  background: #27c4bb;
}

.dashboard-status-table-wrap {
  overflow: auto;
  padding: 20px 18px;
}

.dashboard-status-table table {
  width: 100%;
  min-width: 610px;
  border-collapse: collapse;
  table-layout: fixed;
}

.dashboard-status-table th,
.dashboard-status-table td {
  border-bottom: 1px solid #edf0f4;
  padding: 14px 9px;
  color: #4c5665;
  font-size: 12px;
  text-align: center;
  vertical-align: middle;
}

.dashboard-status-table thead th {
  background: #f8faff;
  color: #718096;
  font-weight: 700;
}

.dashboard-status-table th:first-child {
  width: 104px;
  color: #4c5665;
  font-weight: 800;
  text-align: left;
}

.dashboard-status {
  display: inline-flex;
  min-height: 23px;
  align-items: center;
  border-radius: 999px;
  padding: 2px 8px;
  font-size: 12px;
  font-weight: 700;
  white-space: nowrap;
}

.dashboard-status-ready {
  background: #eaf9f4;
  color: #108563;
}

.dashboard-status-review {
  background: #fff1f2;
  color: #db3d55;
}

.dashboard-status-progress {
  background: #edf4ff;
  color: #1768dc;
}

.dashboard-status-waiting,
.dashboard-status-empty {
  background: #f1f3f6;
  color: #70798a;
}

.dashboard-catalog {
  overflow: hidden;
  border: 1px solid #dfe3ea;
  border-radius: 10px;
  background: #ffffff;
}

.dashboard-catalog-heading {
  margin: 0;
  padding: 20px 20px 14px;
}

.dashboard-result-count {
  display: inline-flex;
  min-height: 28px;
  align-items: center;
  border-radius: 999px;
  background: #eef4ff;
  padding: 0 10px;
  color: #2563c8;
  font-size: 12px;
  font-weight: 700;
}

.dashboard-catalog-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  border-top: 0;
  border-bottom: 1px solid #edf0f4;
  background: transparent;
  padding: 12px var(--db-space-panel) 18px;
}

.dashboard-filter-row {
  display: flex;
  flex-wrap: wrap;
  gap: 7px;
}

.dashboard-filter {
  min-height: 34px;
  border: 0;
  border-radius: 999px;
  background: #f1f4f8;
  padding: 0 12px;
  color: #626c7b;
  font-size: 12px;
  font-weight: 700;
}

.dashboard-filter.is-active {
  border-color: var(--db-primary);
  background: var(--db-primary);
  color: #ffffff;
}

.dashboard-search {
  display: flex;
  width: min(360px, 40%);
  min-height: 38px;
  align-items: center;
  gap: 9px;
  border: 0;
  border-radius: 999px;
  background: #f3f6fa;
  padding: 0 11px;
  color: #98a0ad;
}

.dashboard-search input {
  min-width: 0;
  flex: 1;
  border: 0;
  outline: 0;
  background: transparent;
  color: #242d3b;
  font-size: 12px;
}

.dashboard-search button {
  border: 0;
  background: transparent;
  color: #98a0ad;
}

.dashboard-table-wrap {
  overflow-x: auto;
}

.dashboard-table {
  width: 100%;
  min-width: 960px;
  border-collapse: collapse;
}

.dashboard-table th,
.dashboard-table td {
  border-bottom: 1px solid #edf0f4;
  padding: 14px 18px;
  color: #4c5665;
  font-size: 12px;
  text-align: left;
  vertical-align: middle;
}

.dashboard-table th {
  background: #f5f8fc;
  color: #70798a;
  font-weight: 700;
}

.dashboard-table tbody tr:hover {
  background: #fbfcff;
}

.dashboard-table .is-number {
  text-align: right;
}

.dashboard-table .is-number strong {
  color: #172033;
  font-size: 14px;
}

.dashboard-dataset-name {
  display: flex;
  min-width: 230px;
  align-items: center;
  gap: 10px;
}

.dashboard-dataset-mark {
  display: block;
  width: 10px;
  height: 10px;
  flex: none;
  border-radius: 50%;
  background: linear-gradient(#1c4efc, #21b9d0);
}

.dashboard-dataset-name strong,
.dashboard-dataset-name p {
  display: block;
  overflow: hidden;
  margin: 0;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dashboard-dataset-name strong {
  color: #172033;
  font-size: 13px;
}

.dashboard-dataset-name p {
  max-width: 320px;
  margin-top: 3px;
  color: #8a93a2;
  font-size: 12px;
}

.dashboard-role-list,
.dashboard-connection-list {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
}

.dashboard-role {
  display: inline-flex;
  min-height: 23px;
  align-items: center;
  border-radius: 5px;
  padding: 2px 7px;
  font-size: 12px;
  font-weight: 700;
}

.dashboard-role-reference {
  background: #edf4ff;
  color: #1768dc;
}

.dashboard-role-training {
  background: #f2edff;
  color: #7550db;
}

.dashboard-role-analysis {
  background: #e9f9f6;
  color: #12866e;
}

.dashboard-connection {
  border: 1px solid #e0e5ec;
  border-radius: 4px;
  background: #f8fafc;
  padding: 3px 6px;
  color: #596577;
  font-family: "Liberation Mono", monospace;
  font-size: 12px;
}

.dashboard-empty {
  display: flex;
  min-height: 230px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #98a0ad;
  text-align: center;
}

.dashboard-empty > i {
  font-size: 30px;
}

.dashboard-empty strong {
  margin-top: 13px;
  color: #3f4958;
  font-size: 14px;
}

.dashboard-empty p {
  margin: 5px 0 14px;
  font-size: 12px;
}

.dashboard-empty button {
  min-height: 34px;
  border: 1px solid #cdd7e5;
  border-radius: 7px;
  background: #ffffff;
  padding: 0 12px;
  color: #4c5665;
  font-size: 12px;
  font-weight: 700;
}

.dashboard-footer-note {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  margin: 22px 4px 0;
  color: #7b8494;
  font-size: 12px;
}

.dashboard-footer-note > div {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 7px;
}

.dashboard-footer-note strong {
  color: #4c5665;
}

.dashboard-footer-dot {
  width: 8px;
  height: 8px;
  border-radius: 999px;
  background: #18b67c;
  box-shadow: 0 0 0 4px #e7f8f1;
}

@media (max-width: 1500px) {
  .dashboard-kpi,
  .dashboard-process-card {
    padding: 16px;
  }
  .dashboard-kpi-footer {
    right: 16px;
    left: 16px;
  }
  .dashboard-process-grid,
  .dashboard-recent-grid,
  .dashboard-kpi-grid,
  .dashboard-service-grid,
  .dashboard-insight-grid {
    gap: 12px;
  }
  .dashboard-service-grid {
    grid-template-columns: minmax(0, 1.35fr) minmax(285px, 0.95fr) minmax(270px, 0.9fr);
  }
  .dashboard-analysis-content,
  .dashboard-service-tiles,
  .dashboard-learning-list,
  .dashboard-environment-list {
    gap: 12px;
  }
}
@media (max-width: 1279px) {
  .dashboard-kpi-grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .dashboard-process-grid,
  .dashboard-recent-grid {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
  .dashboard-service-grid {
    grid-template-columns: minmax(0, 1.4fr) minmax(300px, 0.8fr);
  }
  .dashboard-environment {
    grid-column: 1/-1;
  }
  .dashboard-environment-list {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    min-height: 0;
  }
}
@media (max-width: 1023px) {
  .dashboard-shell {
    --db-space-section: 24px;
    padding: 20px 20px 36px;
  }
  .dashboard-kpi-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .dashboard-process-grid,
  .dashboard-recent-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .dashboard-service-grid,
  .dashboard-insight-grid {
    grid-template-columns: 1fr;
  }
  .dashboard-environment {
    grid-column: auto;
  }
}
@media (max-width: 719px) {
  .dashboard-shell {
    padding: 12px;
  }
  .dashboard-notice {
    grid-template-columns: auto minmax(0, 1fr);
  }
  .dashboard-notice button {
    grid-column: 2;
    justify-self: start;
  }
  .dashboard-kpi-grid {
    display: flex;
    margin-right: -12px;
    overflow-x: auto;
    padding-right: 12px;
    padding-bottom: 2px;
    scroll-snap-type: x mandatory;
  }
  .dashboard-kpi {
    width: 256px;
    flex: 0 0 256px;
    scroll-snap-align: start;
  }
  .dashboard-process-grid,
  .dashboard-recent-grid {
    display: flex;
    margin-right: -12px;
    overflow-x: auto;
    padding-right: 12px;
    scroll-snap-type: x mandatory;
  }
  .dashboard-process-card,
  .dashboard-data-card {
    width: 220px;
    flex: 0 0 220px;
    scroll-snap-align: start;
  }
  .dashboard-analysis-content {
    grid-template-columns: 1fr;
  }
  .dashboard-analysis-feature {
    min-height: 270px;
  }
  .dashboard-service-tiles {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .dashboard-environment-list,
  .dashboard-insight-grid {
    grid-template-columns: 1fr;
  }
  .dashboard-catalog-toolbar {
    align-items: stretch;
    flex-direction: column;
  }
  .dashboard-search {
    width: 100%;
  }
  .dashboard-chart-card {
    padding-right: 12px;
    padding-left: 10px;
  }
  .dashboard-footer-note {
    align-items: flex-start;
    flex-direction: column;
  }
}
@media (max-width: 460px) {
  .dashboard-service-tiles {
    grid-template-columns: 1fr;
  }
  .dashboard-service-tiles button {
    min-height: 108px;
  }
  .dashboard-learning-list article {
    align-items: flex-start;
    flex-direction: column;
  }
  .dashboard-course-action {
    align-items: flex-start;
  }
}
:host-context(html[data-theme=dark]) .dashboard-shell {
  --db-ink: #eef4ff;
  --db-text: #c1ccdb;
  --db-muted: #8290a3;
  --db-line: #26374c;
  --db-surface: #101e31;
  --db-canvas: #091524;
}

:host-context(html[data-theme=dark]) .dashboard-kpi,
:host-context(html[data-theme=dark]) .dashboard-process-card,
:host-context(html[data-theme=dark]) .dashboard-data-card,
:host-context(html[data-theme=dark]) .dashboard-service-tiles button,
:host-context(html[data-theme=dark]) .dashboard-learning-list article,
:host-context(html[data-theme=dark]) .dashboard-chart-card,
:host-context(html[data-theme=dark]) .dashboard-status-table-wrap,
:host-context(html[data-theme=dark]) .dashboard-catalog {
  border-color: #26374c;
  background: #101e31;
}

:host-context(html[data-theme=dark]) .dashboard-process-card.is-featured {
  border-color: #4e73ff;
  background: linear-gradient(145deg, #2d5fff, #1f3cc4);
}

:host-context(html[data-theme=dark]) .dashboard-section-heading h2,
:host-context(html[data-theme=dark]) .dashboard-data-card h3,
:host-context(html[data-theme=dark]) .dashboard-learning-list strong,
:host-context(html[data-theme=dark]) .dashboard-dataset-name strong,
:host-context(html[data-theme=dark]) .dashboard-kpi-value,
:host-context(html[data-theme=dark]) .dashboard-empty strong {
  color: #eef4ff;
}

:host-context(html[data-theme=dark]) .dashboard-section-heading p,
:host-context(html[data-theme=dark]) .dashboard-data-card p,
:host-context(html[data-theme=dark]) .dashboard-learning-list p,
:host-context(html[data-theme=dark]) .dashboard-process-copy small {
  color: #94a4b8;
}

:host-context(html[data-theme=dark]) .dashboard-catalog-toolbar,
:host-context(html[data-theme=dark]) .dashboard-table th,
:host-context(html[data-theme=dark]) .dashboard-status-table thead th {
  border-color: #26374c;
  background: #0d1a2b;
}

:host-context(html[data-theme=dark]) .dashboard-table td,
:host-context(html[data-theme=dark]) .dashboard-status-table th,
:host-context(html[data-theme=dark]) .dashboard-status-table td,
:host-context(html[data-theme=dark]) .dashboard-data-card-meta,
:host-context(html[data-theme=dark]) .dashboard-process-count {
  border-color: #26374c;
}

:host-context(html[data-theme=dark]) .dashboard-search,
:host-context(html[data-theme=dark]) .dashboard-filter,
:host-context(html[data-theme=dark]) .dashboard-section-link {
  border-color: #30445e;
  background: #101e31;
  color: #c1ccdb;
}

:host-context(html[data-theme=dark]) .dashboard-search input {
  color: #eef4ff;
}

/* AI Agent dataset-first dashboard */
.dashboard-hero {
  position: relative;
  display: grid;
  min-height: 184px;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: center;
  gap: 28px;
  overflow: hidden;
  border-radius: 30px 30px 30px 10px;
  background: radial-gradient(circle at 88% 4%, rgba(74, 210, 230, 0.26), transparent 34%), linear-gradient(125deg, #102840 0%, #173e5b 64%, #0d7180 100%);
  padding: 30px 32px;
  color: #ffffff;
  box-shadow: 0 22px 52px rgba(20, 48, 74, 0.16);
}

.dashboard-hero::after {
  position: absolute;
  top: -112px;
  right: 78px;
  width: 260px;
  height: 260px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 50%;
  content: "";
}

.dashboard-hero-copy,
.dashboard-hero-actions,
.dashboard-hero-scope {
  position: relative;
  z-index: 1;
}

.dashboard-eyebrow,
.dashboard-hero h1,
.dashboard-hero-description {
  margin: 0;
}

.dashboard-eyebrow {
  color: #79e3f3;
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 0.12em;
}

.dashboard-hero h1 {
  margin-top: 7px;
  font-size: clamp(25px, 2.15vw, 34px);
  font-weight: 820;
  letter-spacing: -0.04em;
  line-height: 1.24;
}

.dashboard-hero-description {
  max-width: 720px;
  margin-top: 10px;
  color: rgba(255, 255, 255, 0.79);
  font-size: 13px;
  line-height: 1.65;
}

.dashboard-context-list {
  display: flex;
  flex-wrap: wrap;
  gap: 7px;
  margin-top: 15px;
}

.dashboard-context-list span {
  display: inline-flex;
  min-height: 28px;
  align-items: center;
  gap: 6px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.07);
  padding: 3px 9px;
  color: rgba(255, 255, 255, 0.88);
  font-size: 12px;
  font-weight: 650;
}

.dashboard-hero-actions {
  display: grid;
  gap: 9px;
}

.dashboard-hero-actions button {
  min-height: 40px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border: 1px solid rgba(255, 255, 255, 0.28);
  border-radius: 999px;
  padding: 0 14px;
  font-size: 12px;
  font-weight: 750;
}

.dashboard-hero-actions .is-secondary {
  background: rgba(255, 255, 255, 0.08);
  color: #ffffff;
}

.dashboard-hero-actions .is-primary {
  border-color: #ffffff;
  background: #ffffff;
  color: #124969;
}

.dashboard-hero-scope {
  min-width: 0;
  border: 1px solid rgba(255, 255, 255, 0.18);
  border-radius: 12px;
  background: rgba(2, 25, 43, 0.23);
  padding: 16px;
  backdrop-filter: blur(8px);
}

.dashboard-hero-scope > span,
.dashboard-hero-scope strong,
.dashboard-hero-scope p,
.dashboard-hero-scope small {
  display: block;
}

.dashboard-hero-scope > span {
  color: #77dfed;
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 0.08em;
}

.dashboard-hero-scope strong {
  margin-top: 7px;
  color: #ffffff;
  font-size: 22px;
  font-weight: 820;
}

.dashboard-hero-scope p {
  margin: 2px 0 0;
  color: rgba(255, 255, 255, 0.82);
  font-size: 12px;
}

.dashboard-hero-scope small {
  margin-top: 10px;
  color: rgba(255, 255, 255, 0.6);
  font-size: 12px;
  line-height: 1.45;
}

.dashboard-hero + .dashboard-kpi-grid {
  margin-top: 20px;
}

.dashboard-kpi-grid {
  gap: 0;
  overflow: hidden;
  border-radius: 24px;
  background: #ffffff;
  padding: 10px 12px;
  box-shadow: 0 14px 36px rgba(32, 55, 88, 0.08);
}

.dashboard-kpi {
  min-height: 116px;
  border: 0 !important;
  border-right: 1px solid #e9eef5 !important;
  border-radius: 0 !important;
  background: transparent !important;
  padding: 16px 20px;
  box-shadow: none !important;
  transform: none !important;
}

.dashboard-kpi:last-child {
  border-right: 0 !important;
}

.dashboard-kpi-heading code {
  border-radius: 6px;
  background: #eef4ff;
  padding: 3px 6px;
  color: #376cca;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 12px;
  font-weight: 800;
}

.dashboard-kpi-value {
  margin-top: 8px;
}

.dashboard-kpi-detail {
  max-width: calc(100% - 44px);
  margin: 5px 0 0;
  overflow: hidden;
  color: #7b8494;
  font-size: 12px;
  line-height: 1.4;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dashboard-kpi > .dashboard-kpi-icon {
  position: absolute;
  right: 17px;
  bottom: 16px;
  width: 36px;
  height: 36px;
}

.dashboard-section-kicker {
  margin: 0 0 3px !important;
  color: #1d67c7 !important;
  font-size: 12px !important;
  font-weight: 800;
  letter-spacing: 0.08em;
}

.dashboard-section-kicker-amber {
  color: #b96300 !important;
}

.dashboard-inventory {
  margin-top: 20px;
}

.dashboard-section-summary {
  display: flex;
  flex: none;
  overflow: hidden;
  border: 1px solid #dfe5ee;
  border-radius: 10px;
  background: #ffffff;
}

.dashboard-section-summary span {
  min-width: 82px;
  display: grid;
  justify-items: center;
  border-right: 1px solid #e8ebf0;
  padding: 8px 12px;
}

.dashboard-section-summary span:last-child {
  border-right: 0;
}

.dashboard-section-summary small {
  color: #8a94a4;
  font-size: 12px;
}

.dashboard-section-summary strong {
  margin-top: 1px;
  color: #172033;
  font-size: 14px;
  font-weight: 800;
}

.dashboard-inventory-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 12px;
}

.dashboard-inventory-card {
  min-width: 0;
  min-height: 218px;
  display: flex;
  flex-direction: column;
  border: 1px solid #dfe4ec;
  border-radius: 12px;
  background: #ffffff;
  padding: 15px;
  transition: border-color 0.18s ease, box-shadow 0.18s ease, transform 0.18s ease;
}

.dashboard-inventory-card:hover {
  border-color: #b4c9ed;
  box-shadow: 0 10px 26px rgba(24, 50, 79, 0.08);
  transform: translateY(-2px);
}

.dashboard-inventory-card > header,
.dashboard-inventory-card > footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 9px;
}

.dashboard-inventory-title {
  min-width: 0;
  display: grid;
  grid-template-columns: auto minmax(0, 1fr);
  align-items: start;
  gap: 10px;
  margin-top: 13px;
}

.dashboard-inventory-icon,
.dashboard-type-icon,
.dashboard-source-icon {
  width: 34px;
  height: 34px;
  display: inline-flex;
  flex: none;
  align-items: center;
  justify-content: center;
  border-radius: 9px;
  background: #edf4ff;
  color: #2268c7;
  font-size: 14px;
}

.dashboard-inventory-title h3,
.dashboard-inventory-title p {
  margin: 0;
}

.dashboard-inventory-title h3 {
  color: #182235;
  font-size: 14px;
  font-weight: 800;
  line-height: 1.4;
}

.dashboard-inventory-title p {
  display: -webkit-box;
  min-height: 37px;
  margin-top: 3px;
  overflow: hidden;
  color: #7b8494;
  font-size: 12px;
  line-height: 1.5;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.dashboard-inventory-card .dashboard-role-list {
  margin-top: 12px;
}

.dashboard-inventory-card > footer {
  margin-top: auto;
  border-top: 1px solid #edf0f4;
  padding-top: 12px;
}

.dashboard-inventory-card > footer > div {
  display: grid;
}

.dashboard-inventory-card > footer > div:last-child {
  justify-items: end;
}

.dashboard-inventory-card > footer strong {
  color: #172033;
  font-size: 18px;
  font-weight: 820;
}

.dashboard-inventory-card > footer small {
  color: #929baa;
  font-size: 12px;
}

.dashboard-overview-grid,
.dashboard-readiness-grid,
.dashboard-scope-grid {
  display: grid;
  gap: 14px;
  margin-top: 20px;
}

.dashboard-overview-grid {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.dashboard-readiness-grid {
  grid-template-columns: repeat(auto-fit, minmax(min(100%, 460px), 1fr));
  gap: 20px;
  margin-top: 28px;
}

.dashboard-scope-grid {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.dashboard-panel {
  min-width: 0;
  overflow: hidden;
  border: 0;
  border-radius: 24px;
  background: #ffffff;
  box-shadow: 0 14px 36px rgba(32, 55, 88, 0.07);
}

.dashboard-panel-header {
  min-height: 72px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  border-bottom: 0;
  padding: 20px var(--db-space-panel) 14px;
}

.dashboard-panel-header h2 {
  margin: 0;
  color: #172033;
  font-size: 16px;
  font-weight: 800;
}

.dashboard-panel-header > span {
  flex: none;
  color: #7c8797;
  font-size: 12px;
  font-weight: 650;
}

.dashboard-type-breakdown {
  display: grid;
}

.dashboard-type-breakdown article {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr);
  align-items: center;
  gap: 12px;
  border-bottom: 1px solid #edf0f4;
  padding: 10px 16px;
}

.dashboard-type-breakdown article:last-child {
  border-bottom: 0;
}

.dashboard-type-breakdown p {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin: 0 0 6px;
}

.dashboard-type-breakdown p strong {
  color: #253044;
  font-size: 13px;
}

.dashboard-type-breakdown p span {
  color: #858f9e;
  font-size: 12px;
}

.dashboard-mini-track {
  position: relative;
  height: 5px;
  overflow: hidden;
  border-radius: 999px;
  background: #edf1f6;
}

.dashboard-mini-track i {
  position: absolute;
  inset: 0 auto 0 0;
  border-radius: inherit;
  background: linear-gradient(90deg, #2767e9, #10a8c1);
}

.dashboard-usage-list {
  display: grid;
  gap: 9px;
  padding: 14px 16px 16px;
}

.dashboard-usage {
  --usage-color: #2767e9;
  display: flex;
  min-height: 67px;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  border: 1px solid #e3e8ef;
  border-left: 3px solid var(--usage-color);
  border-radius: 9px;
  padding: 10px 12px;
}

.dashboard-usage-violet {
  --usage-color: #7854e8;
}

.dashboard-usage-teal {
  --usage-color: #159381;
}

.dashboard-usage strong,
.dashboard-usage p,
.dashboard-usage span {
  margin: 0;
}

.dashboard-usage > div:first-child strong {
  color: #263145;
  font-size: 13px;
}

.dashboard-usage p {
  margin-top: 3px;
  color: #858f9e;
  font-size: 12px;
}

.dashboard-usage > div:last-child {
  display: grid;
  flex: none;
  justify-items: end;
}

.dashboard-usage > div:last-child strong {
  color: var(--usage-color);
  font-size: 17px;
}

.dashboard-usage > div:last-child span {
  color: #939cab;
  font-size: 12px;
}

.dashboard-training-summary {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  overflow: hidden;
  margin: 0 var(--db-space-panel);
  border: 0;
  border-radius: 18px;
  background: #f5f8fc;
}

.dashboard-training-summary > div {
  min-width: 0;
  display: grid;
  border-right: 1px solid #e9edf2;
  padding: 13px 16px;
}

.dashboard-training-summary > div:last-child {
  border-right: 0;
}

.dashboard-training-summary small,
.dashboard-training-summary span {
  overflow: hidden;
  color: #8b95a4;
  font-size: 12px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dashboard-training-summary strong {
  margin: 3px 0;
  color: #172033;
  font-size: 20px;
  font-weight: 820;
}

.dashboard-training-policy strong {
  overflow: hidden;
  font-size: 14px;
  line-height: 1.4;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dashboard-training-profiles {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
  padding: 16px var(--db-space-panel) 20px;
}

.dashboard-training-profiles article {
  min-width: 0;
  border: 0;
  border-radius: 18px;
  background: linear-gradient(135deg, #f8f5ff, #f3f8ff);
  padding: 13px 14px;
}

.dashboard-training-profiles article > div:first-child {
  min-width: 0;
  display: grid;
}

.dashboard-training-profiles article > div:first-child strong,
.dashboard-training-profiles article > div:first-child span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dashboard-training-profiles article > div:first-child strong {
  color: #382f70;
  font-size: 13px;
}

.dashboard-training-profiles article > div:first-child span {
  margin-top: 2px;
  color: #8177a8;
  font-size: 12px;
}

.dashboard-training-profiles article > p {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 8px;
  margin: 10px 0 7px;
}

.dashboard-training-profiles article > p strong {
  color: #4f3fc0;
  font-size: 16px;
}

.dashboard-training-profiles article > p span {
  color: #897faf;
  font-size: 12px;
}

.dashboard-empty-compact {
  grid-column: 1/-1;
  display: grid;
  border: 1px dashed #cfd6e1;
  border-radius: 10px;
  padding: 14px;
}

.dashboard-empty-compact strong,
.dashboard-empty-compact span {
  font-size: 12px;
}

.dashboard-empty-compact span {
  margin-top: 2px;
  color: #858f9e;
}

.dashboard-panel-note {
  display: flex;
  align-items: flex-start;
  gap: 7px;
  margin: 0 var(--db-space-panel) 20px;
  border-radius: 8px;
  background: #f1f4f8;
  padding: 8px 10px;
  color: #727d8d;
  font-size: 12px;
  line-height: 1.45;
}

.dashboard-source-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0;
  padding: 0 var(--db-space-panel) 20px;
}

.dashboard-source-grid article {
  min-width: 0;
  border: 0;
  padding: 16px;
}

.dashboard-source-grid article:nth-child(odd) {
  border-right: 1px dashed #dfe6ef;
}

.dashboard-source-grid article:nth-child(-n+2) {
  border-bottom: 1px dashed #dfe6ef;
}

.dashboard-source-grid header,
.dashboard-source-grid footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.dashboard-source-grid h3,
.dashboard-source-grid p {
  margin: 0;
}

.dashboard-source-grid h3 {
  margin-top: 9px;
  color: #263145;
  font-size: 13px;
}

.dashboard-source-grid p {
  display: -webkit-box;
  min-height: 36px;
  margin-top: 3px;
  overflow: hidden;
  color: #858f9e;
  font-size: 12px;
  line-height: 1.48;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.dashboard-source-grid footer {
  margin-top: 10px;
}

.dashboard-source-grid footer span {
  overflow: hidden;
  color: #939cab;
  font-size: 12px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dashboard-source-grid footer strong {
  flex: none;
  color: #243149;
  font-size: 13px;
}

.dashboard-capability-grid {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  overflow: hidden;
  border: 0;
  border-radius: 24px;
  background: linear-gradient(120deg, #f7faff, #eef6ff);
  padding: 12px;
  box-shadow: 0 14px 36px rgba(32, 55, 88, 0.07);
}

.dashboard-capability-grid article {
  position: relative;
  min-width: 0;
  border-right: 0;
  padding: 16px;
}

.dashboard-capability-grid article:not(:last-child)::after {
  position: absolute;
  top: 18px;
  right: 0;
  bottom: 18px;
  width: 1px;
  background: linear-gradient(transparent, #d8e4f2, transparent);
  content: "";
}

.dashboard-capability-grid article header,
.dashboard-capability-grid article > div:not(.dashboard-mini-track) {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.dashboard-capability-grid code {
  overflow: hidden;
  color: #2366c4;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 12px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dashboard-capability-grid h3,
.dashboard-capability-grid p {
  margin: 0;
}

.dashboard-capability-grid h3 {
  margin-top: 13px;
  color: #202b3e;
  font-size: 13px;
}

.dashboard-capability-grid p {
  display: -webkit-box;
  min-height: 54px;
  margin-top: 4px;
  overflow: hidden;
  color: #818b9a;
  font-size: 12px;
  line-height: 1.5;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
}

.dashboard-capability-grid article > div:not(.dashboard-mini-track) {
  margin: 12px 0 7px;
  color: #8b95a4;
  font-size: 12px;
}

.dashboard-capability-grid article > div strong {
  color: #263145;
  font-size: 12px;
}

.dashboard-catalog {
  overflow: hidden;
  border: 0;
  border-radius: 24px;
  background: #ffffff;
  box-shadow: 0 16px 42px rgba(32, 55, 88, 0.08);
}

.dashboard-catalog > .dashboard-section-heading {
  margin: 0;
  border-bottom: 0;
  padding: 20px var(--db-space-panel) 14px;
}

.dashboard-datasets {
  margin-top: 28px;
}

.dashboard-catalog-type-summary {
  display: flex;
  gap: 10px;
  overflow-x: auto;
  background: transparent;
  padding: 4px var(--db-space-panel) 18px;
}

.dashboard-catalog-type-summary article {
  min-width: max-content;
  display: grid;
  grid-template-columns: auto minmax(0, 1fr) auto;
  align-items: center;
  gap: 9px;
  border: 0;
  border-radius: 999px;
  background: #f3f7fc;
  padding: 8px 12px 8px 8px;
}

.dashboard-catalog-type-summary article:last-child {
  border-right: 0;
}

.dashboard-catalog-type-summary .dashboard-type-icon {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  font-size: 12px;
}

.dashboard-catalog-type-summary article > div {
  min-width: 0;
  display: grid;
}

.dashboard-catalog-type-summary strong,
.dashboard-catalog-type-summary small,
.dashboard-catalog-type-summary b {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dashboard-catalog-type-summary strong {
  color: #273247;
  font-size: 12px;
}

.dashboard-catalog-type-summary small {
  margin-top: 2px;
  color: #8b95a4;
  font-size: 12px;
}

.dashboard-catalog-type-summary b {
  color: #2464c6;
  font-size: 13px;
}

.dashboard-filter {
  display: inline-flex;
  align-items: center;
  gap: 7px;
}

.dashboard-filter small {
  min-width: 20px;
  border-radius: 999px;
  background: #edf1f6;
  padding: 2px 6px;
  color: #687486;
  font-size: 12px;
  line-height: 1.2;
  text-align: center;
}

.dashboard-filter.is-active small {
  background: rgba(255, 255, 255, 0.2);
  color: #ffffff;
}

.dashboard-table {
  min-width: 980px;
  table-layout: fixed;
}

.dashboard-table th:first-child,
.dashboard-table td:first-child {
  width: 27%;
}

.dashboard-table th:nth-child(2),
.dashboard-table td:nth-child(2) {
  width: 11%;
}

.dashboard-table th:nth-child(3),
.dashboard-table td:nth-child(3) {
  width: 15%;
}

.dashboard-table th:nth-child(4),
.dashboard-table td:nth-child(4) {
  width: 8%;
}

.dashboard-table th:nth-child(5),
.dashboard-table td:nth-child(5) {
  width: 26%;
}

.dashboard-table th:last-child,
.dashboard-table td:last-child {
  width: 13%;
}

.dashboard-readiness-list {
  display: grid;
}

.dashboard-readiness-list article {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: center;
  gap: 7px 12px;
  border-bottom: 1px solid #edf0f4;
  padding: 11px 15px;
}

.dashboard-readiness-list article:last-child {
  border-bottom: 0;
}

.dashboard-readiness-list article > div:first-child {
  min-width: 0;
  display: grid;
}

.dashboard-readiness-list strong,
.dashboard-readiness-list span,
.dashboard-readiness-list p {
  margin: 0;
}

.dashboard-readiness-list strong {
  color: #273247;
  font-size: 12px;
}

.dashboard-readiness-list span {
  margin-top: 2px;
  overflow: hidden;
  color: #8b95a4;
  font-size: 12px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dashboard-readiness-list p {
  color: #253044;
  font-size: 12px;
  font-weight: 750;
}

.dashboard-readiness-list .dashboard-mini-track {
  grid-column: 1/-1;
}

.dashboard-fact-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.dashboard-fact-grid article {
  min-width: 0;
  display: grid;
  grid-template-columns: auto minmax(0, 1fr);
  align-items: center;
  gap: 9px;
  border-right: 1px solid #edf0f4;
  border-bottom: 1px solid #edf0f4;
  padding: 13px;
}

.dashboard-fact-grid article:nth-child(2n) {
  border-right: 0;
}

.dashboard-fact-grid article:nth-last-child(-n+2) {
  border-bottom: 0;
}

.dashboard-fact-icon {
  width: 27px;
  height: 27px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: #e8f7f7;
  color: #0f8b82;
  font-size: 12px;
  font-weight: 850;
}

.dashboard-fact-grid p,
.dashboard-fact-grid strong,
.dashboard-fact-grid small {
  display: block;
  margin: 0;
}

.dashboard-fact-grid p,
.dashboard-fact-grid small {
  overflow: hidden;
  color: #8b95a4;
  font-size: 12px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dashboard-fact-grid strong {
  margin: 2px 0;
  color: #223047;
  font-size: 14px;
}

.dashboard-risk-list {
  display: grid;
}

.dashboard-risk-panel {
  margin-top: 28px;
}

.dashboard-risk-panel .dashboard-risk-list {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.dashboard-risk-panel .dashboard-risk:nth-child(odd) {
  border-right: 1px solid #edf0f4;
}

.dashboard-risk-panel .dashboard-risk:nth-last-child(-n+2) {
  border-bottom: 0;
}

.dashboard-risk {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr);
  align-items: start;
  gap: 9px;
  border-bottom: 1px solid #edf0f4;
  padding: 11px 14px;
}

.dashboard-risk:last-child {
  border-bottom: 0;
}

.dashboard-risk > span {
  border: 1px solid #d9e0e9;
  border-radius: 6px;
  padding: 2px 6px;
  color: #647083;
  font-size: 12px;
  font-weight: 700;
}

.dashboard-risk-review > span {
  border-color: #f1c995;
  background: #fff8ec;
  color: #a55b00;
}

.dashboard-risk strong,
.dashboard-risk p {
  margin: 0;
}

.dashboard-risk strong {
  color: #2a3548;
  font-size: 12px;
}

.dashboard-risk p {
  margin-top: 2px;
  color: #8993a2;
  font-size: 12px;
  line-height: 1.45;
}

.dashboard-risk-panel {
  border: 0;
  border-radius: 24px;
  background: linear-gradient(120deg, #fffaf2, #fffdf8);
  box-shadow: none;
}

.dashboard-risk-panel .dashboard-risk-list {
  gap: 10px 28px;
  padding: 2px var(--db-space-panel) 22px;
}

.dashboard-risk-panel .dashboard-risk,
.dashboard-risk-panel .dashboard-risk:nth-child(odd),
.dashboard-risk-panel .dashboard-risk:nth-last-child(-n+2) {
  border: 0;
  padding: 9px 2px;
}

:host-context(html[data-theme=dark]) .dashboard-section-summary,
:host-context(html[data-theme=dark]) .dashboard-inventory-card,
:host-context(html[data-theme=dark]) .dashboard-panel,
:host-context(html[data-theme=dark]) .dashboard-capability-grid,
:host-context(html[data-theme=dark]) .dashboard-catalog {
  border-color: #303b4f;
  background: #151d2b;
}

:host-context(html[data-theme=dark]) .dashboard-inventory-title h3,
:host-context(html[data-theme=dark]) .dashboard-inventory-card > footer strong,
:host-context(html[data-theme=dark]) .dashboard-panel-header h2,
:host-context(html[data-theme=dark]) .dashboard-type-breakdown p strong,
:host-context(html[data-theme=dark]) .dashboard-usage > div:first-child strong,
:host-context(html[data-theme=dark]) .dashboard-training-summary strong,
:host-context(html[data-theme=dark]) .dashboard-source-grid h3,
:host-context(html[data-theme=dark]) .dashboard-capability-grid h3,
:host-context(html[data-theme=dark]) .dashboard-fact-grid strong,
:host-context(html[data-theme=dark]) .dashboard-risk strong {
  color: #e7edf7;
}

:host-context(html[data-theme=dark]) .dashboard-catalog-type-summary {
  background: #111a28;
}

:host-context(html[data-theme=dark]) .dashboard-catalog-type-summary strong {
  color: #e7edf7;
}

.dashboard-footer-note {
  justify-content: flex-end;
}

@media (max-width: 1220px) {
  .dashboard-hero {
    grid-template-columns: minmax(0, 1fr) auto;
  }
  .dashboard-hero-scope {
    display: none;
  }
  .dashboard-inventory-grid,
  .dashboard-capability-grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .dashboard-capability-grid article {
    border-bottom: 1px solid #e8ecf1;
  }
}
@media (max-width: 980px) {
  .dashboard-kpi-grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .dashboard-inventory-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .dashboard-overview-grid,
  .dashboard-readiness-grid,
  .dashboard-scope-grid {
    grid-template-columns: minmax(0, 1fr);
  }
}
@media (max-width: 720px) {
  .dashboard-shell {
    --db-space-panel: 18px;
    --db-space-section: 24px;
    padding: 16px 16px 40px;
  }
  .dashboard-hero {
    grid-template-columns: minmax(0, 1fr);
    padding: 23px 20px;
  }
  .dashboard-hero-actions {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .dashboard-kpi-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    margin-right: 0;
    overflow: hidden;
    padding: 8px;
    scroll-snap-type: none;
  }
  .dashboard-kpi {
    width: auto;
    flex: initial;
    scroll-snap-align: none;
  }
  .dashboard-inventory-grid,
  .dashboard-capability-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .dashboard-hero + .dashboard-kpi-grid {
    margin-top: 18px;
  }
  .dashboard-datasets,
  .dashboard-readiness-grid,
  .dashboard-risk-panel {
    margin-top: 24px;
  }
  .dashboard-catalog > .dashboard-section-heading {
    padding: 20px var(--db-space-panel) 12px;
  }
  .dashboard-catalog-type-summary {
    padding: 4px var(--db-space-panel) 16px;
  }
  .dashboard-catalog-toolbar {
    padding: 12px var(--db-space-panel) 18px;
  }
  .dashboard-panel-header {
    padding: 18px var(--db-space-panel) 12px;
  }
  .dashboard-training-summary {
    margin-right: var(--db-space-panel);
    margin-left: var(--db-space-panel);
  }
  .dashboard-training-profiles,
  .dashboard-source-grid {
    padding-right: var(--db-space-panel);
    padding-left: var(--db-space-panel);
  }
  .dashboard-risk-panel .dashboard-risk-list {
    padding-right: var(--db-space-panel);
    padding-left: var(--db-space-panel);
  }
  .dashboard-capability-grid article::after {
    display: none;
  }
}
@media (max-width: 520px) {
  .dashboard-kpi-grid,
  .dashboard-inventory-grid,
  .dashboard-capability-grid {
    grid-template-columns: minmax(0, 1fr);
  }
  .dashboard-section-heading {
    align-items: stretch;
    flex-direction: column;
  }
  .dashboard-section-summary {
    align-self: flex-start;
  }
  .dashboard-training-summary,
  .dashboard-training-profiles,
  .dashboard-source-grid,
  .dashboard-fact-grid,
  .dashboard-risk-panel .dashboard-risk-list {
    grid-template-columns: minmax(0, 1fr);
  }
  .dashboard-training-summary > div,
  .dashboard-source-grid article,
  .dashboard-source-grid article:nth-child(2n),
  .dashboard-source-grid article:nth-last-child(-n+2),
  .dashboard-fact-grid article,
  .dashboard-fact-grid article:nth-child(2n),
  .dashboard-fact-grid article:nth-last-child(-n+2) {
    border-right: 0;
    border-bottom: 1px solid #e9edf2;
  }
  .dashboard-training-summary > div:last-child,
  .dashboard-source-grid article:last-child,
  .dashboard-fact-grid article:last-child {
    border-bottom: 0;
  }
  .dashboard-risk-panel .dashboard-risk,
  .dashboard-risk-panel .dashboard-risk:nth-child(odd),
  .dashboard-risk-panel .dashboard-risk:nth-last-child(-n+2) {
    border-right: 0;
    border-bottom: 1px solid #edf0f4;
  }
  .dashboard-risk-panel .dashboard-risk:last-child {
    border-bottom: 0;
  }
}`],
})
export class PageDashboardComponent implements OnInit {
    public loading: boolean = true;
    public overviewError: string = '';
    public usingFallback: boolean = false;
    public loadedAt: string = '-';

    public summary: any = {};
    public dataContext: any = {};
    public datasets: any[] = [];
    public modelTraining: any = {};
    public agentSources: any[] = [];
    public agentConnections: any[] = [];
    public risks: any[] = [];

    public datasetQuery: string = '';
    public datasetRole: string = 'all';
    public roleFilters: any[] = [
        { id: 'all', label: '전체' },
        { id: 'reference', label: 'Agent 참조' },
        { id: 'training', label: '학습' },
        { id: 'analysis', label: '분석 근거' },
    ];

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        const allowed = await this.service.auth.allow('/access');
        if (!allowed) return;
        await this.load();
    }

    public async load() {
        this.loading = true;
        this.overviewError = '';
        this.usingFallback = false;
        await this.service.render();

        try {
            const response: any = await wiz.call('overview');
            if (response?.code !== 200 || !response?.data) {
                throw new Error(response?.message || `응답 코드 ${response?.code || '없음'}`);
            }
            this.applyOverview(response.data);
        } catch (error: any) {
            this.applyOverview(this.fallbackOverview());
            this.usingFallback = true;
            const detail = typeof error?.message === 'string' && error.message !== '[object Object]'
                ? ` (${error.message})`
                : '';
            this.overviewError = `최신 집계를 불러오지 못해 내장 Agent 샘플 카탈로그를 표시합니다${detail}.`;
        } finally {
            this.loadedAt = this.formatDateTime(new Date());
            this.loading = false;
            await this.service.render();
        }
    }

    private applyOverview(data: any) {
        const fallback = this.fallbackOverview();
        this.summary = data.summary || fallback.summary;
        this.dataContext = data.dataContext || fallback.dataContext;
        this.datasets = Array.isArray(data.datasets) ? data.datasets : fallback.datasets;
        this.modelTraining = data.modelTraining || fallback.modelTraining;
        this.agentSources = Array.isArray(data.agentSources) ? data.agentSources : fallback.agentSources;
        this.agentConnections = Array.isArray(data.agentConnections) ? data.agentConnections : fallback.agentConnections;
        this.risks = Array.isArray(data.risks) ? data.risks : fallback.risks;
    }

    private fallbackOverview() {
        const datasets = [
            { id: 'process-history', name: '공정 실행 이력', description: '공정 조건·결과 검색과 샘플 모델 학습 입력', type: '정형 데이터', typeKey: 'structured', roles: ['reference', 'training', 'analysis'], connections: ['process.search', 'trace.compare', 'model.predict', 'semiconductor.data'], roleLabels: ['Agent 참조', '학습', '분석 근거'], usageLabel: '학습·조회 가능', recordCount: 42, status: 'ready', statusLabel: '사용 가능', updatedAt: '2026-05-18', owner: 'Process Intelligence', fields: ['lot', 'recipe', 'equipment', 'yieldScore'] },
            { id: 'sensor-trace', name: '센서 시계열', description: '장비 신호 이상 탐지와 RCA 근거', type: '시계열', typeKey: 'timeseries', roles: ['reference', 'analysis'], connections: ['trace.compare', 'semiconductor.data'], roleLabels: ['Agent 참조', '분석 근거'], usageLabel: 'Agent 조회 가능', recordCount: 40, status: 'ready', statusLabel: '사용 가능', updatedAt: '2026-05-18', owner: 'Equipment Data', fields: ['sensor', 'window', 'baseline', 'trend'] },
            { id: 'metrology-quality', name: '계측·품질 결과', description: '두께·CD·결함·균일도의 Agent 원본 조회 문맥', type: '정형 데이터', typeKey: 'structured', roles: ['reference'], connections: ['semiconductor.data'], roleLabels: ['Agent 참조'], usageLabel: 'Agent 조회 가능', recordCount: 30, status: 'ready', statusLabel: '사용 가능', updatedAt: '2026-05-18', owner: 'Metrology', fields: ['metric', 'value', 'target', 'status'] },
            { id: 'equipment-master', name: '장비 마스터', description: '장비·챔버·담당 조직 기본 참조 정보', type: '마스터 데이터', typeKey: 'master', roles: ['reference'], connections: ['semiconductor.data'], roleLabels: ['Agent 참조'], usageLabel: 'Agent 조회 가능', recordCount: 16, status: 'ready', statusLabel: '사용 가능', updatedAt: '2026-05-18', owner: 'Equipment Data', fields: ['vendor', 'chamber', 'recipe', 'owner'] },
            { id: 'recipe-knowledge', name: 'Recipe 지식', description: '공정 목표와 제어 파라미터 참조', type: '지식 데이터', typeKey: 'knowledge', roles: ['reference'], connections: ['semiconductor.data'], roleLabels: ['Agent 참조'], usageLabel: 'Agent 조회 가능', recordCount: 15, status: 'ready', statusLabel: '사용 가능', updatedAt: '2026-05-18', owner: 'Process Integration', fields: ['target', 'parameters', 'controls'] },
            { id: 'lot-trace', name: 'Lot 추적 정보', description: '제품·공정 경로·수율의 Lot 단위 검색 문맥', type: '정형 데이터', typeKey: 'structured', roles: ['reference'], connections: ['semiconductor.data'], roleLabels: ['Agent 참조'], usageLabel: 'Agent 조회 가능', recordCount: 12, status: 'ready', statusLabel: '사용 가능', updatedAt: '2026-05-18', owner: 'Manufacturing Data', fields: ['product', 'route', 'currentStep', 'status'] },
            { id: 'center-line-master', name: '센터·라인 정보', description: '센터 위치·연구 분야·데이터 소유자 문맥', type: '마스터 데이터', typeKey: 'master', roles: ['reference'], connections: ['semiconductor.data'], roleLabels: ['Agent 참조'], usageLabel: 'Agent 조회 가능', recordCount: 5, status: 'ready', statusLabel: '사용 가능', updatedAt: '2026-05-18', owner: 'Data Governance', fields: ['location', 'focus', 'equipmentIds', 'dataOwner'] },
            { id: 'event-alarm-log', name: '이벤트·알람 로그', description: '장비 이벤트와 알람의 Agent 원본 조회 문맥', type: '이벤트 로그', typeKey: 'event', roles: ['reference'], connections: ['semiconductor.data'], roleLabels: ['Agent 참조'], usageLabel: 'Agent 조회 가능', recordCount: 16, status: 'ready', statusLabel: '사용 가능', updatedAt: '2026-05-18', owner: 'Equipment Data', fields: ['time', 'equipment', 'severity', 'message'] },
        ];

        return {
            summary: {
                totalDatasets: 8,
                totalRecords: 176,
                readyDatasets: 8,
                preparingDatasets: 0,
                dataTypeCount: 5,
                capabilityCount: 5,
                modelCount: 2,
                usableTrainingRows: 28,
                builtInReferenceChunks: 3,
                approvedReferenceDocuments: 0,
                approvedReferenceChunks: 0,
                userDatasets: 0,
                userDatasetRows: 0,
                referenceChunks: 3,
                connectedSourceCount: 2,
            },
            dataContext: {
                mode: 'sample',
                modeLabel: 'AI Agent 샘플',
                source: 'Semiconductor Dummy Dataset · Agent Dataset Adapter',
                basisTime: '2026-05-18',
                freshness: 'static',
                freshnessLabel: '정적 샘플',
                note: '기존 샘플 176건을 중복 생성하지 않고 Agent 참조·학습·분석 용도로 분류했습니다.',
            },
            datasets,
            modelTraining: {
                status: 'ready',
                statusLabel: '학습 가능',
                dataScope: 'sample',
                sourceDataset: '공정 실행 이력',
                sourceRecords: 42,
                usableRecords: 28,
                maxRowsPerRun: 12,
                fitMode: '요청마다 로컬 재학습',
                models: ['vm-thickness', 'etch-endpoint-anomaly'],
                profiles: [
                    { modelId: 'vm-thickness', sourceRecords: 42, usableRecords: 28, criteria: '온도·압력·전력·시간·두께' },
                    { modelId: 'etch-endpoint-anomaly', sourceRecords: 42, usableRecords: 42, criteria: '압력·전력·시간' },
                ],
                note: '운영 생산 판정용 모델이 아닌 기능 검증용 샘플 모델입니다.',
            },
            agentSources: [
                { id: 'structured-sample', name: '반도체 구조화 샘플', type: '도구 기반 참조·학습', datasetCount: 8, itemCount: 176, unit: '건', status: 'connected', statusLabel: 'Agent 연결', description: '전체 8종은 semiconductor.data로 조회하며 공정·센서 일부는 전용 도구에도 투입합니다.' },
                { id: 'built-in-rag', name: '내장 참조 지식', type: '문서 RAG', datasetCount: 1, itemCount: 3, unit: 'chunks', status: 'connected', statusLabel: 'RAG 연결', description: '근거가 포함된 반도체 가이드 샘플을 키워드 검색에 사용합니다.' },
                { id: 'approved-documents', name: '승인 사용자 문서', type: 'ACL 적용 문서 RAG', datasetCount: 0, itemCount: 0, unit: 'chunks', status: 'empty', statusLabel: '등록 없음', description: '현재 로그인 사용자가 읽을 수 있는 승인 문서만 집계합니다.' },
                { id: 'user-dataset-store', name: '사용자 데이터셋 저장소', type: '버전형 행 데이터', datasetCount: 0, itemCount: 0, unit: 'rows', status: 'empty', statusLabel: '등록 없음', description: '저장·조회 기능과 Agent 질의 어댑터는 분리되어 있습니다.' },
            ],
            agentConnections: [
                { id: 'structured-data', capability: 'semiconductor.data', name: '반도체 데이터 전체 조회', description: '8개 구조화 컬렉션을 원본 필드와 함께 Agent 문맥으로 제공', datasetCount: 8, readyCount: 8, readiness: 100, status: 'ready', statusLabel: '연결됨' },
                { id: 'process-search', capability: 'process.search', name: '공정 데이터 검색', description: '자연어 조건을 공정 이력 필터와 원본 레코드 조회로 연결', datasetCount: 1, readyCount: 1, readiness: 100, status: 'ready', statusLabel: '연결됨' },
                { id: 'trace-compare', capability: 'trace.compare', name: 'Trace 파형 비교', description: '공정 실행 이력과 센서 시계열을 기준 파형과 비교', datasetCount: 2, readyCount: 2, readiness: 100, status: 'ready', statusLabel: '연결됨' },
                { id: 'sample-model', capability: 'model.predict', name: '샘플 모델 예측', description: '공정 이력에서 요청별 학습 표본을 선택해 로컬 모델 실행', datasetCount: 1, readyCount: 1, readiness: 100, status: 'ready', statusLabel: '연결됨' },
                { id: 'rag-search', capability: 'rag.search', name: '근거 문서 검색', description: '내장 샘플과 ACL이 적용된 승인 문서 chunk를 검색', datasetCount: 1, readyCount: 1, readiness: 100, status: 'ready', statusLabel: '연결됨' },
            ],
            risks: [
                { title: '작은 학습 표본', detail: '요청마다 최대 12개 샘플 행을 선택하므로 검증 지표가 불안정할 수 있습니다.', level: 'review' },
                { title: '정적 샘플 데이터', detail: '운영 최신성을 나타내지 않으며 Agent 기능 검증 용도로만 사용합니다.', level: 'info' },
                { title: '운영 모델 대체 불가', detail: '샘플 모델 결과를 생산 판정이나 공정 제어 근거로 사용하면 안 됩니다.', level: 'info' },
                { title: '조회 범위와 자동 입력 구분', detail: '8종은 도구로 조회 가능하지만 개별 질의에는 선택된 Agent 도구의 데이터만 투입됩니다.', level: 'info' },
            ],
        };
    }

    public summaryCards() {
        return [
            {
                label: '전체 Agent 데이터셋',
                value: this.summary.totalDatasets || 0,
                unit: '종',
                detail: '학습·참조 데이터 통합 카탈로그',
                tone: 'blue',
                code: 'ALL',
            },
            {
                label: 'Agent 참조 데이터셋',
                value: this.roleDatasetCount('reference'),
                unit: '종',
                detail: '구조화 조회 · 문서 RAG',
                tone: 'teal',
                code: 'REF',
            },
            {
                label: 'Agent 학습 데이터셋',
                value: this.roleDatasetCount('training'),
                unit: '종',
                detail: '요청별 로컬 모델 학습 입력',
                tone: 'violet',
                code: 'TRAIN',
            },
            {
                label: '데이터 유형',
                value: this.summary.dataTypeCount || 0,
                unit: '종',
                detail: '정형 · 시계열 · 마스터 · 지식 · 이벤트',
                tone: 'amber',
                code: 'TYPES',
            },
            {
                label: '전체 레코드',
                value: this.summary.totalRecords || 0,
                unit: '건',
                detail: 'Agent 기능 검증용 정적 샘플',
                tone: 'cyan',
                code: 'ROWS',
            },
        ];
    }

    public summaryIcon(index: number) {
        const icons = [
            'fa-cubes-stacked',
            'fa-book-open',
            'fa-brain',
            'fa-shapes',
            'fa-database',
        ];
        return icons[index] || 'fa-chart-simple';
    }

    public trainingProfiles() {
        return (this.modelTraining?.profiles || []).slice(0, 3);
    }

    public roleDatasetCount(role: string) {
        return (this.datasets || []).filter((item: any) => (item.roles || []).includes(role)).length;
    }

    public datasetTypeBreakdown() {
        const rows: any = {};
        for (const dataset of (this.datasets || [])) {
            const typeKey = String(dataset.typeKey || 'structured');
            if (!rows[typeKey]) {
                rows[typeKey] = {
                    typeKey,
                    label: dataset.type || typeKey,
                    datasetCount: 0,
                    recordCount: 0,
                };
            }
            rows[typeKey].datasetCount += 1;
            rows[typeKey].recordCount += Number(dataset.recordCount || 0);
        }
        const order = ['structured', 'timeseries', 'master', 'knowledge', 'event'];
        return order
            .filter((key: string) => rows[key])
            .map((key: string) => rows[key]);
    }

    public datasetIcon(typeKey: string) {
        const icons: any = {
            structured: 'fa-table-list',
            timeseries: 'fa-wave-square',
            master: 'fa-server',
            knowledge: 'fa-book-open',
            event: 'fa-bell',
        };
        return icons[typeKey] || 'fa-database';
    }

    public profilePercent(profile: any) {
        const total = Number(profile?.sourceRecords || 0);
        if (total <= 0) return 0;
        return Math.max(0, Math.min(100, Math.round((Number(profile?.usableRecords || 0) / total) * 100)));
    }

    public filteredDatasets() {
        const query = String(this.datasetQuery || '').trim().toLowerCase();
        return (this.datasets || []).filter((item: any) => {
            const roleMatches = this.datasetRole === 'all' || (item.roles || []).includes(this.datasetRole);
            if (!roleMatches) return false;
            if (!query) return true;
            const haystack = [
                item.name,
                item.description,
                item.type,
                item.owner,
                ...(item.roleLabels || []),
                ...(item.fields || []),
                ...(item.connections || []),
            ].join(' ').toLowerCase();
            return haystack.includes(query);
        });
    }

    public setDatasetRole(role: string) {
        this.datasetRole = role;
    }

    public clearDatasetFilters() {
        this.datasetQuery = '';
        this.datasetRole = 'all';
    }

    public roleFilterClass(role: string) {
        return this.datasetRole === role
            ? 'dashboard-filter is-active'
            : 'dashboard-filter';
    }

    public metricClass(tone: string) {
        return `dashboard-kpi dashboard-kpi-${tone}`;
    }

    public datasetTypeClass(type: string) {
        const map: any = {
            structured: 'dashboard-type dashboard-type-blue',
            timeseries: 'dashboard-type dashboard-type-cyan',
            master: 'dashboard-type dashboard-type-slate',
            knowledge: 'dashboard-type dashboard-type-violet',
            event: 'dashboard-type dashboard-type-amber',
        };
        return map[type] || map.structured;
    }

    public statusClass(status: string) {
        const map: any = {
            ready: 'dashboard-status dashboard-status-ready',
            connected: 'dashboard-status dashboard-status-ready',
            complete: 'dashboard-status dashboard-status-ready',
            pass: 'dashboard-status dashboard-status-ready',
            review: 'dashboard-status dashboard-status-review',
            progress: 'dashboard-status dashboard-status-progress',
            waiting: 'dashboard-status dashboard-status-waiting',
            empty: 'dashboard-status dashboard-status-empty',
            unavailable: 'dashboard-status dashboard-status-review',
        };
        return map[status] || map.empty;
    }

    public roleClass(role: string) {
        const map: any = {
            reference: 'dashboard-role dashboard-role-reference',
            training: 'dashboard-role dashboard-role-training',
            analysis: 'dashboard-role dashboard-role-analysis',
        };
        return map[role] || map.reference;
    }

    public roleLabel(role: string) {
        const map: any = {
            reference: 'Agent 참조',
            training: '학습',
            analysis: '분석 근거',
        };
        return map[role] || role;
    }

    public riskClass(level: string) {
        return `dashboard-risk dashboard-risk-${level || 'info'}`;
    }

    public riskLabel(level: string) {
        const map: any = {
            review: '검토',
            progress: '진행',
            info: '안내',
        };
        return map[level] || '안내';
    }

    public sourceValue(value: any) {
        if (value === null || value === undefined) return '-';
        return this.formatNumber(value);
    }

    public formatNumber(value: any) {
        const parsed = Number(value || 0);
        return Number.isFinite(parsed) ? parsed.toLocaleString('ko-KR') : String(value || '-');
    }

    public trainingModelName(model: string) {
        const map: any = {
            'vm-thickness': '두께 Virtual Metrology',
            'etch-endpoint-anomaly': '공정 이상 탐지',
            'sample-vm-thickness': '두께 Virtual Metrology',
            'sample-process-anomaly': '공정 이상 탐지',
            'sample-vm-thickness-v1': '두께 Virtual Metrology',
            'sample-process-anomaly-v1': '공정 이상 탐지',
        };
        return map[model] || model;
    }

    public formatDateTime(value: Date) {
        const pad = (part: number) => String(part).padStart(2, '0');
        return `${value.getFullYear()}-${pad(value.getMonth() + 1)}-${pad(value.getDate())} ${pad(value.getHours())}:${pad(value.getMinutes())}`;
    }

    public openDataHub() {
        this.service.href('/agent/history');
    }

    public openAgent() {
        this.service.href('/agent/chat');
    }
}

export default PageDashboardComponent;